// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

// Create a utility function for API calls
export const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
      'Content-Type': 'application/json',
      'Authorization': token || '',
    };
};

/**
 * Constructs the full API URL from a relative path
 */
export const getApiUrl = (path: string): string => {
  // If path already starts with http, return as-is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};

/**
 * Enhanced fetch wrapper that handles authentication errors globally
 * Automatically redirects to login on 401 (token expiration)
 */
export const authenticatedFetch = async (
  url: string,
  options: RequestInit = {}
): Promise<Response> => {
  const token = localStorage.getItem('token');
  
  // Construct full URL
  const fullUrl = getApiUrl(url);
  
  // Merge auth headers with any custom headers provided
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': token || '',
    ...options.headers,
  };

  const response = await fetch(fullUrl, {
    ...options,
    headers,
  });

  // Handle 401 Unauthorized (token expired or invalid)
  if (response.status === 401) {
    // Clear the expired token
    localStorage.removeItem('token');
    
    // Redirect to login page
    window.location.href = '/login';
    
    // Throw error to stop further processing
    throw new Error('Session expired. Please login again.');
  }

  return response;
};